import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentStatusComponent } from './appointment-status/appointment-status.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [AppointmentStatusComponent, TermsAndConditionsComponent, PrivacyPolicyComponent],
  exports:[AppointmentStatusComponent, TermsAndConditionsComponent, PrivacyPolicyComponent],
  imports: [
    IonicModule,
    CommonModule,
    //IonicModule.forRoot()
  ]  
})
export class SharedModule { }
